module.exports = __webpack_public_path__ + "9524750_s.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/9524750_s.jpg
// module id = 270
// module chunks = 0